import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Breadcrumb/sgds-breadcrumb-item";
import { register } from "../../utils/ce-registry";

register("sgds-breadcrumb-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-breadcrumb-item",
  elementClass: Component,
  events: {}
});
